class KBLinksService {
    get(anchor) {
        const url = 'https://telemetron.atlassian.net/wiki/spaces/TTS/pages/4180574223?parentProduct=JSM&parentProductContentContainerId=10820&initialAllowedFeatures=byline-contributors.sticky-header.delete&locale=ru-RU'
        const dictionary = {
            dashboard: 'Раздел-«Главная»',
            vms: 'Раздел-«Торговые-автоматы»',
            vms_new: 'Создание-нового-автомата',
            vm_card: 'Карточка-торгового-автомата',
            correction: 'Создание-чека-коррекции',
            modems: 'Раздел-«Модемы»',
            add_modem: 'Регистрация-модема-Оптима-в-личном-кабинете-Lite',
            products: 'Раздел-«Каталог-продуктов»',
            new_planogram: 'Создание-планограмм',
            add_product: 'Создание-продуктов',
            add_recipe: 'Создание-рецептов',
            add_ingredients: 'Создание-ингредиентов',
            profile: 'Профиль-компании',
            crt: 'Подключение-облачной-кассы-к-кабинету'
        }

        return `${url}#${dictionary[anchor]}`
    }
}

export default new KBLinksService()
